import * as types from '../mutation-types';
import { createActionHelpers } from 'vuex-loading';

const { startLoading, endLoading } = createActionHelpers({
    moduleName: 'loader',
});

export default {
    namespaced: true,
    state: {
        stockList: [],
    },
    getters: {
        stockList: state => state.stockList,
    },
    mutations: {
        [types.SET_STOCK_LIST](state, stockList) {
            state.stockList = stockList;
        },
    },
    actions: {
        async getStockList({ commit, dispatch }, params = {}) {
            startLoading(dispatch, 'fetch-stocks');

            const options = {
                params: Object.assign(
                    {
                        query: null,
                        limit: 15,
                    },
                    params,
                ),
            };

            try {
                const { data } = await axios.get(
                    Laroute.route('data_api.stocks'),
                    options,
                );
                commit(types.SET_STOCK_LIST, data);
                endLoading(dispatch, 'fetch-stocks');

                return data;
            } catch (e) {
                throw e;
            }
        },
    },
};



// WEBPACK FOOTER //
// ./resources/assets/js/store/modules/stock.js